export default {
  list: [],
  selected: {}
}
